import type { RichTextField } from '@prismicio/client';
import type {
  BlogArticleDocumentDataContentItem,
  Simplify,
} from '../../../../../../../../prismicio-types';

import styles from './sideBar.module.scss';

import { ArticleTable } from './ArticleTable/ArticleTable';
import { CalculatorProps } from '@/types';
import { Calculator } from '@/components';

interface SideBarProps {
  table: Simplify<BlogArticleDocumentDataContentItem>[];
  tableTitle: RichTextField;
  offsetElement: string;
  calculatorProps: CalculatorProps;
}

export const SideBar = ({
  table,
  tableTitle,
  offsetElement,
  calculatorProps,
}: SideBarProps) => {
  return (
    <div className={styles.side_bar_wrapper}>
      <div className={styles.side_bar}>
        {table.length > 0 && (
          <ArticleTable
            content={table}
            title={tableTitle}
            offsetElement={offsetElement}
          />
        )}
        <Calculator data={calculatorProps} />
      </div>
    </div>
  );
};
